$(function () {
    if ($('a.productDetail-quantityDiscounts').length) {
        $('a.productDetail-quantityDiscounts').on('click', function () {
            $(this).toggleClass('isOpen');
            return false;
        })
    }
});